export default {
    brand_name: '通通AI助手',
    employURL: 'https://www.shanghaijimu.com/ai_user.html', // 使用协议
    privacyURL: 'https://www.shanghaijimu.com/privacy.html', // 隐私协议、
    baseYM: 'pad-api.jmkjsh.com',
    baseURL: 'https://pad-api.jmkjsh.com',
    baseURLFile: 'https://convert-test.shanghaijimu.com',
    baseURLWPS: 'https://wps.shanghaijimu.com',
    wss: 'wss:/pad-api.jmkjsh.com/ws/tts'
};
